import React, { useEffect, useState } from 'react';
import { getTemplates } from './api/templateApi';
import { getStudents } from './api/studentApi';
import { getTrainers } from './api/trainerApi';

function ChatSendMessageModal({ show, onClose, onSend, loading }) {
  const [templates, setTemplates] = useState([]);
  const [students, setStudents] = useState([]);
  const [trainers, setTrainers] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [selectedStudent, setSelectedStudent] = useState('');
  const [selectedTrainer, setSelectedTrainer] = useState('');
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    if (show) {
      setFetching(true);
      Promise.all([
        getTemplates(),
        getStudents(),
        getTrainers()
      ]).then(([templateData, studentData, trainerData]) => {
        setTemplates(templateData.templates || templateData);
        setStudents(studentData.students || studentData);
        setTrainers(trainerData.trainers || trainerData);
      }).finally(() => setFetching(false));
    } else {
      // Reset selections when modal is closed
      setSelectedStudent('');
      setSelectedTrainer('');
      setSelectedTemplate('');
      setTitle('');
      setMessage('');
    }
  }, [show]);

  useEffect(() => {
    if (selectedTemplate) {
      const tpl = templates.find(t => t.id === Number(selectedTemplate));
      if (tpl) {
        setTitle(tpl.title || '');
        setMessage(tpl.message || '');
      }
    }
  }, [selectedTemplate, templates]);

  const handleSend = (e) => {
    e.preventDefault();
    if (!selectedTemplate || (!selectedStudent && !selectedTrainer) || !title || !message) return;
    onSend({
      title,
      message,
      receiver_student_id: selectedStudent,
      receiver_trainer_id: selectedTrainer
    });
  };

  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog" style={{background: 'rgba(0,0,0,0.3)'}}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <form onSubmit={handleSend}>
            <div className="modal-header">
              <h5 className="modal-title">Send a Message</h5>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {fetching ? <div>Loading...</div> : <>
                <div className="mb-3">
                  <label className="form-label">Select a Template</label>
                  <select className="form-select" value={selectedTemplate} onChange={e => setSelectedTemplate(e.target.value)} required>
                    <option value="">Select Template</option>
                    {templates.map(t => <option key={t.id} value={t.id}>{t.title}</option>)}
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">Select a Student</label>
                  <select className="form-select" value={selectedStudent} onChange={e => {
                    setSelectedStudent(e.target.value);
                    if (e.target.value) setSelectedTrainer('');
                  }} required={!selectedTrainer}>
                    <option value="">Select Student</option>
                    {students.map(s => <option key={s.id} value={s.id}>{s.User?.full_name || s.full_name}</option>)}
                  </select>
                </div>
                <div className="mb-3">
                  <div className="text-center text-muted mb-2">-- OR --</div>
                  <label className="form-label">Select a Trainer</label>
                  <select className="form-select" value={selectedTrainer} onChange={e => {
                    setSelectedTrainer(e.target.value);
                    if (e.target.value) setSelectedStudent('');
                  }} required={!selectedStudent}>
                    <option value="">Select Trainer</option>
                    {trainers.map(t => <option key={t.id} value={t.id}>{t.User?.full_name || t.full_name}</option>)}
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">Title</label>
                  <input type="text" className="form-control" value={title} onChange={e => setTitle(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Message</label>
                  <textarea className="form-control" value={message} onChange={e => setMessage(e.target.value)} required />
                </div>
              </>}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
              <button type="submit" className="btn btn-primary" disabled={loading || fetching || !selectedTemplate || (!selectedStudent && !selectedTrainer) || !title || !message}>Send</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ChatSendMessageModal; 